module.exports = __webpack_public_path__ + "static/media/ribosomal_seqs.a715904b.csv";